<template>
  <div style="padding: 0">
    <b-row style="padding: 0">
      <b-col cols="4" v-if="unit == true" style="padding: 0">
        <b-form-input
          :disabled="unitValidate"
          style="padding: 3px"
          placeholder="Birim(m)"
          v-model="params.data.unit" 
        />
      </b-col>
      <b-col cols="4" style="padding: 0">
        <b-form-input
          style="padding: 3px"
          placeholder="Adet"
          v-model="girilenDeger"
          @input="adetkontrol"
        />
      </b-col>
      <b-col cols="4" style="padding: 0">
        <vs-button
          v-if="isAuth && isAuth != null && isAuth != 'null'"
          @click="stockDetail()"
          color="success"
          type="filled"
          size="small"
          icon="add"
          style="border-radius: 5px; padding: 0"
        ></vs-button>
        <vs-button
          v-else
          @click="goToLogin()"
          color="success"
          type="filled"
          size="small"
          icon="add"
          style="border-radius: 5px; padding: 0"
        ></vs-button>
        <p style="display: none">{{ adetDeger }} {{ birimDeger }}</p>
      </b-col>
    </b-row>
    <b-modal
      ref="modal-primary"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      hide-header
      hide-title
      hide-footer
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <LOGIN :loginTanim="loginTanim" />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../store/store";
import state from "../../../store/state";
import userJson from "../../../../public/user.json";
import LOGIN from "../../pages/Login.vue";

export default {
  components: {
    LOGIN, 
  },
  data() {
    return {
      unit: userJson.unit,
      unitVal: "",
      VALUE: "",
      girilenDeger: "",
      adetDeger: "",
      birimDeger: "",
      unitValidate: false,
      loginTanim: true,
      isAuth: Store.state.tokenId,
    };
  },

  methods: {
    goToLogin() {
      this.$refs["modal-primary"].show();
    },
    stockDetail() {
      var sepetek = [];
      sepetek.push({
        quantity: this.params.data.adet,
        stockQuantity: this.params.data.quantity,
        renkAciklamasi: this.params.data.colorName,
        bedenAdi: this.params.data.size,
        fiyat:
          typeof this.params.data.fiyat == "undefined"
            ? this.params.data.price
            : this.params.data.fiyat,
        barcode: this.params.data.barcode,
        productCode: this.params.data.stockCode,
        ONAY: this.params.data.ONAY,
        productName: this.params.data.stockName,
        kdv: this.params.data.vat,
        price:
          typeof this.params.data.fiyat == "undefined"
            ? this.params.data.price
            : this.params.data.fiyat,
        customerCode: this.$store.state.UserId,
        unit: parseFloat(this.params.data.unit) == 0 ? 1 : this.params.data.unit,
        image:  this.params.data.image,
        customerName: this.$store.state.B2BfirmaAdi,
      });  
      this.$store
        .dispatch("eCommerce/additemInCartToplu", sepetek[0])
        .then((response) => {
          if (response == "ok") {
            this.$root.$emit("sepetListGet");

            var vs = this.$vs;
            this.secilenAdetDegeri = "";
            vs.notify({
              title: "Başarılı",
              text: "Seçilen ürün sepete eklendi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          }
        });
    },
    birimkontrol() {
      this.params.data.unit = this.unitVal;
      this.birimDeger = this.params.data.unit;
    },
    adetkontrol() {
      if (userJson.eksiliStok == false) {
        if (this.girilenDeger > this.params.data.quantity) {
          var vs = this.$vs;
          vs.notify({
            title: "Uyarı",
            text: "Seçilen adet, depo stoğundan büyük olamaz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          this.params.data.adet = this.params.data.quantity;
          this.girilenDeger = this.params.data.quantity;
          this.adetDeger = this.params.data.adet;
        } else {
          this.params.data.adet = this.girilenDeger;
          this.adetDeger = this.params.data.adet;
        }
      } else {
        this.params.data.adet = this.girilenDeger;
        this.adetDeger = this.params.data.adet;
      }
    },
    changedVal() {
      this.params.data.adet = this.girilenDeger;
      this.adetDeger = this.params.data.adet;
    },
  },
  created() {
    if (!this.params.data.stockCode.includes("-M")) {
      this.unitVal = 100;
      this.unitValidate = true;
    }
  },
};
</script>
